<template>
    <div class="table-detail mt-4">
      <b-row class="mb-2">
        <b-col cols="9"><h5 class="card-title font-weight-bolder text-dark">{{ title }}</h5></b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="app-table-input">
            <div class="app-table-corner">
              <!-- table disini -->
              <b-table-simple id="elemen-kompetensi" 
                class="app-table-content-input"
                :bordered="false"
                stacked="md" 
                :no-local-sorting="true" 
                head-variant="head-light" 
                small
                :busy="isDataLoading" 
                v-bind="$attrs"
                >
                <b-thead head-variant="head-light">
                    <b-tr>
                        <b-th class="action"></b-th>
                        <b-th class="th_style" v-for="head in fields" v-bind:key="head.key">{{ head.label }}</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr class="td_border" v-for="item in items" v-bind:key="item.id" :class="(item.evenOddGroup == 0) ? 'table_even_bg' : 'table_odd_bg'">
                        <b-td class="td_border" v-if="item.isMainRow" :rowspan="(item.rowSpan == 1) ? null : item.rowSpan">
                            <div class="div-actions">
                                <span>
                                    <b-overlay
                                        rounded
                                        opacity="0.6"
                                        spinner-small
                                        spinner-variant="primary"
                                        class="d-inline-block"
                                    >
                                    <b-button size="sm" @click="editRowAction(item)" class="mr-2 btn-xs btn-default-white">
                                      <b-icon-pencil></b-icon-pencil>
                                    </b-button>
                                    <click-confirm>
                                        <b-button size="sm" @click="deleteRowAction(item)" class="mr-2 btn-xs btn-transparent btn-color-danger border-0">
                                        <b-icon-trash></b-icon-trash>
                                        </b-button>
                                    </click-confirm>
                                    </b-overlay>
                                </span>
                            </div>
                        </b-td>
                        <b-td class="td_border" v-for="col in item.row" v-bind:key="col.id" :rowspan="col.rowSpan">{{ col.value }}</b-td>
                    </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
            <b-row class="mt-2 mb-2">
              <b-col cols="12" lg="4">
                  <div class="mt-3 mt-lg-0">
                    <slot name="table-paging"></slot>
                  </div>
              </b-col>
              <b-col cols="4" class="text-center align-self-center">
                {{ items | isDataExists}}
              </b-col>
              <b-col cols="12" lg="12">
                  <b-button v-if="showAddButton" class="btn-secondary float-right mr-1 ml-1 mt-3 w-100 btn-table-add" size="sm" @click="showPopupAddAction"><b-icon-plus></b-icon-plus><span class="ml-1">Add Data</span></b-button>
                  <slot name="add-row-button"></slot>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col cols="12">
                <slot name="form-add-detail"></slot>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
                <slot name="upload-detail"></slot>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
</template>
<style lang="scss" scoped>
  ::v-deep.b-table-top-row {
    background-color: #f1f1f1!important;
  }

  .table_even_bg {
    background-color: #FFF !important;
  }

  .table_odd_bg {
    background-color: var(--table-striped-color);
  }

  .td_border {
    border: 1px solid #e5e4e4 !important;
  }

  .th_style {
    text-align: center;
  }
</style>
<script>
export default {
    props: ["sort-by", "sort-desc", "sortBy", "sortDesc","options", "showActionButton", "showEditButton", "showDeleteButton", "showSelectAll", "isDataLoading", "isDownloadBusy", "showAddButton", "showAddFromClipboardButton", "showReplaceFromClipboardButton", "showDownloadButton", "showUploadButton", "showPaging", "downloadCaption", "title", "fields", "items"],
    data() {
        return {
            sortByStr : "",
            sortDescStr : ""
        }
    },
    mounted() {
      
    },
    filters: {
        isDataExists: function (value) {
          let dataNotExists = 'No data yet...';
            if (value != null && value != "") {
              if (value.length > 0) return "";  
              return dataNotExists;
            } else {
              return dataNotExists;
            }
        }
    },
    methods: {
        setSelected(value) {
            this.inputModel = value;
        },
        addButtonAction() {
          this.$emit("addButtonMethod");
        },
        uploadButtonAction(modalEvent) {
          modalEvent.preventDefault();
          this.$emit("uploadButtonMethod", modalEvent);
        },
        editRowAction(item) {
          console.log('editRowAction', item);
          let itemId = item.itemId;
          this.$emit("editButtonMethod", itemId, item);
        },
        deleteRowAction(item) {
          let itemId = item.itemId;
          this.$emit("deleteButtonMethod", itemId, item);
        },
        showPopupAddAction() {
          this.$emit("showPopupAddMethod");
        },
        showPopupUploadAction() {
          this.$emit("showPopupUploadMethod");
        },
        addFromClipboardAction() {
          this.$emit("addFromClipboardMethod");
        },
        replaceFromClipboardAction() {
          this.$emit("replaceFromClipboardMethod");
        },
        downloadAction() {
          this.$emit("downloadMethod");
        },
        sortByAction(){
          this.$emit("sortByMethod", this.sortBy);
        },
        sortDescAction(){
          this.$emit("sortDescMethod",this.sortDesc);
        }
    },
    computed : {
      downloadStr() {
        if (this.downloadCaption != null && this.downloadCaption != undefined && this.downloadCaption != "") return this.downloadCaption;
        return "Download";
      },
       hasEditButtonSlot() {
        return !!this.$slots['edit-button'] || !!this.$scopedSlots['edit-button'];
      },

    },
    watch : {
      sortBy : {
          handler: function() {
            this.sortByAction();
        }
      },
      sortDesc : {
          handler: function() {
            this.sortDescAction();
        }
      },
      sortByStr(newStr) {
        this.$emit('update:sort-by', newStr);
      },
      sortDescStr(newStr) {
        this.$emit('update:sort-desc', newStr);
      }
    }, 
}
</script>
<style lang="scss" scoped>
::v-deep .modal-body {
  background: #EEF0F8 !important;
}
@media (min-width: 768px) {
  ::v-deep .modal-detail {
      width: 50% !important;
      height: 80% !important;
      margin-top: 4.75rem !important;
  } 
}
</style>